import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
export default function LoaderCircle(props) {
return (
    <CircularProgress style={{color: '#0b678f'}}/>
)
};
